/* unplugin-vue-components disabled */import script from "./batch-delete-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./batch-delete-dialog.vue?vue&type=script&lang=ts&setup=true"

import "./batch-delete-dialog.vue?vue&type=style&index=0&id=91e49cf4&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91e49cf4"]])

export default __exports__